import React, { ReactElement, useState } from "react";
import styled from "styled-components/macro";

import GanttLogo from "../../../icons/GanttLogo.png";
import { GenericButton } from "../common/Buttons";

const TextBox = styled.input`
  width: 400px;
  height: 40px;
  padding: 11px;
  border: 1px solid #78899a;
  border-radius: 1px;
  margin-bottom: 15px;
`;

const Label = styled.span`
  width: 400px;
  height: 19px;
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 5px;
`;

interface ITextInputProps {
  label: string;
  inputType: string;
  value: string;
  onChange: (newValue: string) => void;
}

export const TextInput = (props: ITextInputProps): ReactElement => {

  const [value,setValue] = useState(props.value);

  const handleChange = (event) => {
    setValue(event.target.value);
    props.onChange(event.target.value);
  };

  return (
    <>
      <Label>{props.label}</Label>
      <TextBox type={props.inputType} value={value} onChange={handleChange} />
    </>
  );
};

export const LoginButton = styled(GenericButton)`
  position: absolute;
  bottom: 0px;
  left: 35%;
  margin-top: 15px;
  margin-bottom: 15px;
  text-transform: uppercase;
`;

export const AzureLoginLink = styled.div`
  cursor: pointer;
`;

export const LoginLanguageContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 85%;
`;

export const GanttLogoContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 35%;
  width: 170px;
  height: 28px;
  background-image: url(${(_) => GanttLogo});
  background-size: contain;
  background-repeat: no-repeat;
`;

interface IHeaderProps {
  color: string;
}
export const Header = styled.div`
  position: absolute;
  top: 10px;
  font-size: 20px;
  line-height: 27px;
  height: 27px;
  margin-right: auto;
  color: ${(props: IHeaderProps) => props.color};
  text-transform: uppercase;
`;

export const LoginOuter = styled.div`
  overflow: hidden;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const LoginBoxInner = styled.div`
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  width: 441px;
  max-width: 441px;
  height: 364px;
  padding-left: 20px;
  padding-top: 10px;

  background: #ffffff;
  border: 2px solid #6a9844;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  flex: 1 1 auto;
`;

export const LoginFailure = styled.div`
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  width: 441px;
  max-width: 441px;
  height: 279px;
  padding-left: 10px;
  padding-top: 10px;

  background: #ffffff;
  border: 2px solid #c65911;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export const FailureMessage = styled.div`
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  flex-basis: 120px;
`;
